import { render } from "./SizeInputs.vue?vue&type=template&id=3579f8eb"
import script from "./SizeInputs.vue?vue&type=script&lang=js"
export * from "./SizeInputs.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__